export type Predicate<T = unknown> = (x: T) => boolean;
export const isDefined: Predicate = (x) => (x ?? null) !== null;
export const isNonNullable = <T>(x: T): x is NonNullable<T> => x !== null && x !== undefined;
